export const doctorIdLocalStorageKey = 'doctorId';
export const contextLocalStorageKey = 'context';
export const getAppConfigKey = () => `patientAppConfig(${getDoctorId()})`;

const updatePatientAppConfig = config => {
    const patientAppConfig = getPatientAppConfig();
    localStorage.setItem(getAppConfigKey(), JSON.stringify({ ...patientAppConfig, ...config }));
};

const getPatientAppConfig = () => {
    const localPatientAppConfig = localStorage.getItem(getAppConfigKey());
    if (!localPatientAppConfig) {
        return {};
    }

    try {
        return JSON.parse(localPatientAppConfig);
    } catch {
        localStorage.setItem(getAppConfigKey(), "{}");
        return {};
    }
};

const getDoctorId = () => {
    return localStorage.getItem(doctorIdLocalStorageKey) || '';
};

const updateDoctorId = doctorId => {
    localStorage.setItem(doctorIdLocalStorageKey, doctorId || '');
};

const getContext = () => {
    return localStorage.getItem(contextLocalStorageKey) || '';
}

const updateContext = (context) => {
    localStorage.setItem(contextLocalStorageKey, context || '');
}

export default {
    getPatientAppConfig,
    updatePatientAppConfig,
    getDoctorId,
    updateDoctorId,
    getContext,
    updateContext
};
